import { uniqBy } from 'lodash';
import { GlobalAction, ContactsState, initialState } from '.';
import { ContactListItem } from '../api/types';

const GET_CONTACTS_START = 'GET_CONTACTS_START';
const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
const GET_CONTACTS_ERROR = 'GET_CONTACTS_ERROR';
const ADD_CONTACT_START = 'ADD_CONTACT_START';
const ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS';
const ADD_CONTACT_ERROR = 'ADD_CONTACT_ERROR';
const BULK_CONTACT_UPDATE_START = 'BULK_CONTACT_UPDATE_START';
const BULK_CONTACT_UPDATE_SUCCESS = 'BULK_CONTACT_UPDATE_SUCCESS';
const BULK_CONTACT_UPDATE_ERROR = 'BULK_CONTACT_UPDATE_ERROR';
const DELETE_CONTACTS_ERROR = 'DELETE_CONTACTS_ERROR';
const DELETE_CONTACTS_START = 'DELETE_CONTACTS_START';
const DELETE_CONTACTS_SUCCESS = 'DELETE_CONTACTS_SUCCESS';
const ADD_CONTACTS_SUCCESS = 'ADD_CONTACTS_SUCCESS';
const GET_GROUPS_START = 'GET_GROUPS_START';
const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
const GET_GROUPS_ERROR = 'GET_GROUPS_ERROR';
const GET_GROUP_START = 'GET_GROUP_START';
const GET_GROUP_SUCCESS = 'GET_GROUP_SUCCESS';
const GET_GROUP_ERROR = 'GET_GROUP_ERROR';
const ADD_GROUP_START = 'ADD_GROUP_START';
const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
const ADD_GROUP_ERROR = 'ADD_GROUP_ERROR';
const DELETE_GROUPS_START = 'DELETE_GROUPS_START';
const DELETE_GROUPS_SUCCESS = 'DELETE_GROUPS_SUCCESS';
const DELETE_GROUPS_ERROR = 'DELETE_GROUPS_ERROR';
const EDIT_GROUP_START = 'EDIT_GROUP_START';
const EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS';
const EDIT_GROUP_ERROR = 'EDIT_GROUP_ERROR';
const GET_OPT_OUTS_START = 'GET_OPT_OUTS_START';
const GET_OPT_OUTS_SUCCESS = 'GET_OPT_OUTS_SUCCESS';
const GET_OPT_OUTS_ERROR = 'GET_OPT_OUTS_ERROR';
const GET_GROUP_CONTACTS_START = 'GET_GROUP_CONTACTS_START';
const GET_GROUP_CONTACTS_SUCCESS = 'GET_GROUP_CONTACTS_SUCCESS';
const GET_GROUP_CONTACTS_ERROR = 'GET_GROUP_CONTACTS_ERROR';
const DELETE_GROUP_CONTACT_START = 'DELETE_GROUP_CONTACT_START';
const DELETE_GROUP_CONTACT_SUCCESS = 'DELETE_GROUP_CONTACT_SUCCESS';
const DELETE_GROUP_CONTACT_ERROR = 'DELETE_GROUP_CONTACT_ERROR';

export const contactsReducer = (
  state: ContactsState,
  action: GlobalAction
): ContactsState => {
  const { payload, type } = action;
  switch (type) {
    case GET_CONTACTS_SUCCESS: {
      return {
        ...state,
        contacts: {
          items: payload.contacts,
          count: payload.count,
          page: payload.page,
          size: payload.size,
          search: payload.search,
          loading: false,
        },
      };
    }
    case ADD_CONTACT_SUCCESS: {
      return {
        ...state,
        contacts: {
          items: [...state.contacts.items, payload.contact].slice(
            0,
            state.contacts.size
          ),
          count: state.contacts.count + 1,
          page: state.contacts.page,
          size: state.contacts.size,
          loading: false,
        },
      };
    }
    case ADD_CONTACTS_SUCCESS: {
      return {
        ...state,
        contacts: {
          items: [...state.contacts.items, ...payload.contacts].slice(
            0,
            state.contacts.size
          ),
          count: state.contacts.count + payload.count,
          page: state.contacts.page,
          size: state.contacts.size,
          loading: false,
        },
      };
    }

    case BULK_CONTACT_UPDATE_SUCCESS: {
      const { contacts, groups } = payload;
      const updatedContacts = state.contacts.items.map(cc => {
        contacts.forEach((up: any) => {
          if (cc.contactId === up.contactId) {
            return up;
          }
        });
        return cc;
      });
      const updatedGroups = groups.map((up: any) => {
        const group = state.groups.items.find(g => g.groupId === up.groupId);
        const groupContacts = uniqBy(
          [...((group && group.contacts) || []), ...contacts],
          'contactId'
        );
        return { ...up, contacts: groupContacts };
      });

      return {
        ...state,
        contacts: {
          ...state.contacts,
          items: updatedContacts,
        },
        groups: {
          ...state.groups,
          items: uniqBy([...updatedGroups, ...state.groups.items], 'groupId'),
        },
      };
    }

    case DELETE_CONTACTS_SUCCESS: {
      return {
        ...state,
        contacts: {
          items: state.contacts.items.filter(
            c => !payload.data.includes(c.contactId)
          ),
          count: state.contacts.count + payload.contacts.length,
          page: state.contacts.page,
          size: state.contacts.size,
          search: state.contacts.search,
          loading: true,
        },
        groups: {
          ...state.groups,
          selected: {
            ...state.groups.selected,
            contacts: {
              items:
                state.groups.selected &&
                state.groups.selected.contacts &&
                state.groups.selected.contacts.items &&
                state.groups.selected.contacts.items.filter(
                  (c: ContactListItem) => !payload.data.includes(c.contactId)
                ),
              count: state.contacts.count + payload.contacts.length,
              page: state.contacts.page,
              size: state.contacts.size,
            },
          },
        },
      };
    }
    case DELETE_GROUP_CONTACT_SUCCESS: {
      return {
        ...state,
        groups: {
          ...state.groups,
          selected: {
            ...state.groups.selected,
            contacts: {
              items: state.groups.selected.contacts.items.filter(
                (c: ContactListItem) => c.contactId !== payload.contactId
              ),
              count: state.contacts.count - 1,
              page: state.contacts.page,
              size: state.contacts.size,
            },
          },
        },
      };
    }
    case GET_GROUPS_SUCCESS: {
      return {
        ...state,
        groups: {
          ...state.groups,
          items: payload.groups,
          count: payload.count,
          page: payload.page,
          size: payload.size,
          search: payload.search,
          loading: false,
          selected: { ...initialState.groups.selected, loading: true },
        },
      };
    }
    case GET_GROUP_SUCCESS: {
      return {
        ...state,
        groups: {
          ...state.groups,
          selected: { ...state.groups.selected, ...payload.group },
        },
      };
    }
    case GET_GROUP_CONTACTS_START: {
      return {
        ...state,
        groups: {
          ...state.groups,
          selected: {
            ...state.groups.selected,
            loading: true,
          },
        },
      };
    }
    case GET_GROUP_CONTACTS_SUCCESS: {
      return {
        ...state,
        groups: {
          ...state.groups,
          selected: {
            ...state.groups.selected,
            loading: false,
            contacts: {
              items: payload.contacts,
              count: payload.count,
              page: payload.page,
              size: payload.size,
              search: payload.search,
            },
          },
        },
      };
    }
    case ADD_GROUP_SUCCESS: {
      return {
        ...state,
        groups: {
          items: [
            ...state.groups.items,
            { contacts: [], ...payload.group },
          ].slice(0, state.groups.size),
          selected: { ...state.groups.selected },
          count: state.groups.count + 1,
          page: state.groups.page,
          size: state.groups.size,
        },
      };
    }

    case DELETE_GROUPS_SUCCESS: {
      return {
        ...state,
        groups: {
          items: state.groups.items.filter(
            c => !payload.data.includes(c.groupId)
          ),
          count: state.groups.count + payload.groups.length,
          page: state.groups.page,
          size: state.groups.size,
          search: state.groups.search,
          loading: false,
          selected: { ...initialState.groups.selected, loading: false },
        },
      };
    }
    case EDIT_GROUP_SUCCESS: {
      const updatedGroup = state.groups.items.find(
        c => c.groupId === payload.group.groupId
      );

      let selected = { ...state.groups.selected };
      if (selected.groupId === payload.group.groupId) {
        selected.name = payload.group.name;
      }

      const items = [...state.groups.items];
      if (updatedGroup) {
        items[items.indexOf(updatedGroup)] = payload.group;
      }

      return {
        ...state,
        groups: {
          ...state.groups,
          items,
          selected,
        },
      };
    }
    case GET_OPT_OUTS_SUCCESS: {
      return {
        ...state,
        optOuts: {
          items: payload.optOuts,
          count: payload.count,
          page: payload.page,
          size: payload.size,
          search: payload.search,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
};

export const CONTACTS_ACTIONS = {
  GET_CONTACTS_START,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_ERROR,
  ADD_CONTACT_START,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACTS_SUCCESS,
  BULK_CONTACT_UPDATE_START,
  BULK_CONTACT_UPDATE_SUCCESS,
  BULK_CONTACT_UPDATE_ERROR,
  DELETE_CONTACTS_START,
  DELETE_CONTACTS_SUCCESS,
  DELETE_CONTACTS_ERROR,
  ADD_CONTACT_ERROR,
  GET_GROUPS_START,
  GET_GROUPS_SUCCESS,
  GET_GROUPS_ERROR,
  GET_GROUP_START,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  GET_GROUP_CONTACTS_START,
  GET_GROUP_CONTACTS_SUCCESS,
  GET_GROUP_CONTACTS_ERROR,
  ADD_GROUP_START,
  ADD_GROUP_SUCCESS,
  ADD_GROUP_ERROR,
  DELETE_GROUPS_START,
  DELETE_GROUPS_SUCCESS,
  DELETE_GROUPS_ERROR,
  EDIT_GROUP_START,
  EDIT_GROUP_SUCCESS,
  EDIT_GROUP_ERROR,
  GET_OPT_OUTS_START,
  GET_OPT_OUTS_SUCCESS,
  GET_OPT_OUTS_ERROR,
  DELETE_GROUP_CONTACT_START,
  DELETE_GROUP_CONTACT_SUCCESS,
  DELETE_GROUP_CONTACT_ERROR,
};
